module.exports = __webpack_public_path__ + "img/icon_showroom.f174b0a1.svg";